import { CalendarType } from "./CalendarType";

export class Calendar {
    title: string;
    type: CalendarType = CalendarType.other;
    outlookDeltaLink: string;
    id = 0;
}
